import jwtDecode from 'jwt-decode'
import useAuthStore from '@/store/auth'
import useUserStore from '@/store/user'

export default async function useLocalStorage(accessTokenFlow) {
  const { setAccessTokenFlow } = useAuthStore()
  const { setUserData } = useUserStore()

  setAccessTokenFlow(accessTokenFlow)

  const decoded = jwtDecode(accessTokenFlow)
  const user = {
    id: decoded.nameid,
    nome: decoded.unique_name,
    empresaId: decoded.ide,
  }
  setUserData(user)
}
